import React, { Component } from 'react';
import { translate } from '../Services/translation';
import BuyButtonContainer from '../Containers/BuyButton.Container';

class StickyDetails extends Component {
    constructor(props) {
        super(props);
        this.productImage = "";
        this.state = {
            hasScrolled: false,
        }
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleScroll() {
        let scrollReached = false;
        const marginScroll = 220;
        const currentScroll = window.pageYOffset;
        if (currentScroll === 0 || currentScroll < marginScroll) {
            scrollReached = false;
        }
        else if (window.innerHeight + currentScroll + marginScroll >= document.body.offsetHeight) {
            scrollReached = false
        }
        else if (currentScroll > marginScroll) {
            scrollReached = true;
        }
        this.setState({
            hasScrolled: scrollReached
        })
    }

    render() {
        const { product, priceLists } = this.props;
        if (!product) {
            return (
                <></>
            );
        }
        const isInStock = product && product.isInStock;
        const articleNumber = isInStock ? product.id : null;
        const buttonLabel = isInStock ? translate("cart.selectcar") : translate("cart.outofstock");
        const buttonCss = isInStock ? "button buy-button configurator-summary__buy-button" : "button buy-button configurator-summary__buy-button disabled";
        const buyButton = { label: buttonLabel, articleNumber, cssClass: buttonCss, productType: product.productTypeId }

        let productTotalPrice = null;
        let currency = null;
        //if (product && product.price && product.price.price) {
        //    productTotalPrice = product.price.price.priceWithVat
        //}
        //else {
        //    productTotalPrice = "-"
        //}
        productTotalPrice = product.priceFormated;
        if (product) {
            currency = product.currency.symbol;
        }

        const imageUrl = product.imageThumbnail;
        const altText = product.name;
        const stockStatus = product.stockStatus;

        const selectedPriceListDisplayName = priceLists.find(x => x.isSelected).displayName;

        return (
            <div className={`sticky-details small-12 large-8 ${this.state.hasScrolled ? 'sticky-details--visible' : ''}`}>
                <div className="sticky-details__content">
                    <div className="sticky-details__content__image show-for-large">
                        <img src={imageUrl} alt={altText} />
                    </div>
                    <div className="sticky-details__content__price">{productTotalPrice} {/*{currency}*/}
                        <div className="sticky-details__content__price__pricemodel">{selectedPriceListDisplayName}</div>
                        <div className="sticky-details__content__price__deliverytime">{stockStatus}</div>
    
                    </div>
                    <div className="sticky-details__content__buybutton">
                        <BuyButtonContainer {...buyButton} />
                    </div>
                </div>
            </div>
        )
    }
}

export default StickyDetails;